import { useCallback, useState } from 'react';
import informeListService from '../services/informeListService';

function useInformeList() {
  const [informes, setInformes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await informeListService.getAll();
      setInformes(data);
      return data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchByTipo = useCallback(async (tipo) => {
    setLoading(true);
    setError(null);
    setInformes([]);

    try {
      const data = await informeListService.getByTipo(tipo);
      setInformes(data);
      return data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    informes,
    loading,
    error,
    fetchAll,
    fetchByTipo,
    fetchInformes: fetchAll,
  };
}

export default useInformeList;
